<template><div><p>在部分用户看来这是一个使用门槛，实际上它本意是为了让用户更方便地开发。</p>
<p>它是为了实现按需引用组件及定义 less 变量以及编译时优化代码而开发的，并不会造在配置上的麻烦，具体使用时仅仅是需要调用 <code>merge</code> 方法合并原有 webpack 配置。</p>
</div></template><script>
export default {
  head: {"title":"为什么一定要使用 vux-loader | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// why-using-vux-loader-148.vue?0abeb064